import { render, staticRenderFns } from "./Interaction.vue?vue&type=template&id=620c9549&scoped=true"
import script from "./Interaction.vue?vue&type=script&lang=js"
export * from "./Interaction.vue?vue&type=script&lang=js"
import style0 from "./Interaction.vue?vue&type=style&index=0&id=620c9549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c9549",
  null
  
)

export default component.exports